<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-main">
        <NfsePrefeituraCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import NfsePrefeituraCreateUpdate from '../../../components/modules/tax-document/nfse-prefeitura/NfsePrefeituraCreateUpdate.vue';

export default {
  name: "NfsePrefeituraCreateUpdateView",
  components: {
    ViewTemplateWithSalveCancel,
    NfsePrefeituraCreateUpdate
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Nota Fiscal",
        title: "Nfse Prefeitura",
        formName: "nfsePrefeituraCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
};
</script>
